import { api, tr } from './shared';

export function getPublicApiV1Sections(lang) {
  return [
    {
      id: 'public-api-v1-overview',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'Public API v1 — обзор', 'Public API v1 — overview'),
      blocks: [
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        {
          type: 'text',
          value: tr(
            lang,
            'Public API v1 предназначен для полноценной работы с данными организации: карты, клиенты, карточки клиентов и транзакции (начисление/списание бонусов, штампы, скидки).',
            'Public API v1 is designed for full access to organization data: cards, clients, client cards and transactions (accrual/write-off of bonuses, stamps, discounts).',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Аутентификация', 'Authentication'),
          items: [
            tr(lang, 'Authorization: Bearer <USER_TOKEN> — JWT-токен пользователя Loyal Club', 'Authorization: Bearer <USER_TOKEN> — Loyal Club user JWT token'),
            tr(lang, 'X-Api-Key: <API_KEY> — API ключ организации (рекомендуется для серверных интеграций)', 'X-Api-Key: <API_KEY> — organization API key (recommended for server integrations)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Коды ответов', 'Response codes'),
          items: [
            tr(lang, '200 — успешно', '200 — success'),
            tr(lang, '401 — не авторизован (невалидный или отсутствующий токен/ключ)', '401 — unauthorized (invalid or missing token/key)'),
            tr(lang, '403 — нет доступа (недостаточно scope у API ключа)', '403 — forbidden (insufficient API key scope)'),
            tr(lang, '404 — ресурс не найден или не принадлежит вашей организации', '404 — resource not found or not owned by your organization'),
            tr(lang, '409 — конфликт (дубликат, связанные данные)', '409 — conflict (duplicate, related data)'),
            tr(lang, '422 — ошибка валидации (пропущены обязательные поля, неверный формат)', '422 — validation error (missing required fields, wrong format)'),
            tr(lang, '429 — превышен лимит запросов (rate limit)', '429 — too many requests (rate limit)'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Все эндпоинты возвращают только данные вашей организации. Межорганизационный доступ невозможен.',
            'All endpoints return only your organization\'s data. Cross-organization access is impossible.',
          ),
        },
      ],
    },
    {
      id: 'public-api-v1-data-model',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Концепции', 'Concepts'),
      navSubgroupOrder: 1,
      navOrder: 10,
      navLabel: tr(lang, 'Модель данных', 'Data model'),
      title: tr(lang, 'Модель данных', 'Data model'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Система строится на четырёх ключевых сущностях, связанных иерархически.',
            'The system is built on four key entities linked hierarchically.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Связи сущностей', 'Entity relationships'),
          key: 'v1-data-model-diagram',
          value: `Organization (организация)\n  └── Card (карта лояльности — шаблон программы)\n  └── Client (клиент — физическое лицо)\n        └── ClientCard (карточка клиента — связка Card ↔ Client)\n              └── Transaction (операция — начисление, списание, штамп)`,
        },
        {
          type: 'list',
          title: tr(lang, 'Описание сущностей', 'Entity descriptions'),
          items: [
            tr(lang, 'Organization — ваша компания. Все данные привязаны к ней. API ключ даёт доступ только к данным одной организации.', 'Organization — your company. All data is bound to it. API key grants access to one organization only.'),
            tr(lang, 'Card — шаблон программы лояльности (штампы, кэшбэк, скидка, подписка, сертификат). Создаётся один раз, выпускается клиентам.', 'Card — loyalty program template (stamps, cashback, discount, subscription, certificate). Created once, issued to clients.'),
            tr(lang, 'Client — физическое лицо (покупатель). Содержит контактные данные: телефон, email, имя.', 'Client — a person (customer). Contains contact data: phone, email, name.'),
            tr(lang, 'ClientCard — выпущенная карта конкретного клиента. Хранит баланс (штампы, бонусы, кэшбэк), номер карты. Одна Card может быть выпущена одному Client только один раз.', 'ClientCard — issued card of a specific client. Stores balance (stamps, bonuses, cashback), card number. One Card can be issued to one Client only once.'),
            tr(lang, 'Transaction — единичная операция (начисление, списание, штамп, покупка). Привязана к конкретной ClientCard. Влияет на баланс карточки.', 'Transaction — single operation (accrual, write-off, stamp, purchase). Bound to a specific ClientCard. Affects card balance.'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Типичный сценарий: создать Client → выпустить ему ClientCard (привязать к Card) → записывать Transactions.',
            'Typical flow: create Client → issue ClientCard (link to Card) → record Transactions.',
          ),
        },
      ],
    },
    {
      id: 'public-api-v1-card-types',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Концепции', 'Concepts'),
      navSubgroupOrder: 1,
      navOrder: 20,
      navLabel: tr(lang, 'Типы карт', 'Card types'),
      title: tr(lang, 'Типы карт (card.status)', 'Card types (card.status)'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Поле status у Card определяет тип программы лояльности и логику работы карточки клиента. Вот все поддерживаемые типы:',
            'The status field of a Card defines the loyalty program type and client card behavior. All supported types:',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'stamp — штампы (накопительная)', 'stamp — stamps (collectible)'),
          items: [
            tr(lang, 'Клиент собирает штампы за покупки/визиты', 'Customer collects stamps for purchases/visits'),
            tr(lang, 'Поле stamps в ClientCard — текущее количество штампов', 'stamps field in ClientCard — current stamp count'),
            tr(lang, 'Поле available_rewards — количество накопленных наград (подарков)', 'available_rewards field — accumulated reward count'),
            tr(lang, 'Штампы добавляются через POST /api/v1/transactions с gifts_given > 0', 'Stamps are added via POST /api/v1/transactions with gifts_given > 0'),
            tr(lang, 'Награда (reward) выдаётся автоматически при достижении порога (настраивается в карте)', 'Reward is given automatically when threshold is reached (configured in card)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'cashback — кэшбэк (бонусная)', 'cashback — cashback (bonus)'),
          items: [
            tr(lang, 'Клиент копит бонусы (кэшбэк) с каждой покупки', 'Customer accumulates bonus (cashback) from each purchase'),
            tr(lang, 'Поле cashback_balance в ClientCard — текущий бонусный баланс', 'cashback_balance field in ClientCard — current bonus balance'),
            tr(lang, 'Поле cashback_percent — процент начисления кэшбэка', 'cashback_percent field — cashback accrual percentage'),
            tr(lang, 'Начисление: POST /api/v1/transactions с points_issued > 0 (бонусы)', 'Accrual: POST /api/v1/transactions with points_issued > 0 (bonuses)'),
            tr(lang, 'Списание: POST /api/v1/transactions с points_issued < 0 (отрицательное значение)', 'Write-off: POST /api/v1/transactions with points_issued < 0 (negative value)'),
            tr(lang, 'total_spent — общая сумма покупок клиента', 'total_spent — total customer purchases amount'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'discount — скидочная', 'discount — discount'),
          items: [
            tr(lang, 'Клиент получает фиксированную или накопительную скидку', 'Customer gets fixed or progressive discount'),
            tr(lang, 'Поле discount_percent в ClientCard — текущий процент скидки', 'discount_percent field in ClientCard — current discount percentage'),
            tr(lang, 'total_spent отслеживает общую сумму покупок (для прогрессивных уровней)', 'total_spent tracks total spend (for progressive tiers)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'subscription — подписка', 'subscription — subscription'),
          items: [
            tr(lang, 'Клиент подписан на услуги/программу', 'Customer is subscribed to services/program'),
            tr(lang, 'Может иметь срок действия (card_expiration_date)', 'May have expiration date (card_expiration_date)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'certificate — сертификат', 'certificate — certificate'),
          items: [
            tr(lang, 'Карта-сертификат с фиксированным номиналом', 'Certificate card with fixed face value'),
            tr(lang, 'cashback_balance используется как остаток по сертификату', 'cashback_balance is used as certificate remaining balance'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Тип карты задаётся при создании Card (поле status). При выпуске ClientCard через POST /api/v1/client-cards/issue тип наследуется автоматически.',
            'Card type is set when creating a Card (status field). When issuing a ClientCard via POST /api/v1/client-cards/issue, the type is inherited automatically.',
          ),
        },
      ],
    },
    {
      id: 'public-api-v1-event-values',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Концепции', 'Concepts'),
      navSubgroupOrder: 1,
      navOrder: 30,
      navLabel: tr(lang, 'Типы событий (event)', 'Event types'),
      title: tr(lang, 'Типы событий транзакций (event)', 'Transaction event types'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Поле event в транзакции определяет тип операции. При создании транзакции через API вы указываете event самостоятельно. Ниже — все используемые значения.',
            'The event field in a transaction defines the operation type. When creating a transaction via API you specify event yourself. Below are all values used in the system.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Штампы (stamp-карты)', 'Stamps (stamp cards)'),
          items: [
            tr(lang, 'stamp_add — начисление штампа клиенту', 'stamp_add — stamp accrual to customer'),
            tr(lang, 'stamp_cancel — отмена начисления штампа', 'stamp_cancel — stamp accrual cancellation'),
            tr(lang, 'reward_given — клиент накопил достаточно штампов, ему начислена награда (подарок)', 'reward_given — customer accumulated enough stamps, reward is granted'),
            tr(lang, 'reward_received — клиент получил/забрал награду', 'reward_received — customer received/claimed reward'),
            tr(lang, 'reward_cancel — отмена награды', 'reward_cancel — reward cancellation'),
            tr(lang, 'reward_received_cancel — отмена получения награды', 'reward_received_cancel — reward receipt cancellation'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Кэшбэк/бонусы (cashback-карты)', 'Cashback/bonuses (cashback cards)'),
          items: [
            tr(lang, 'cashback_accrued — начисление бонусов (кэшбэк с покупки)', 'cashback_accrued — bonus accrual (cashback from purchase)'),
            tr(lang, 'cashback_spent — списание бонусов', 'cashback_spent — bonus write-off'),
            tr(lang, 'cashback_adjustment — ручная корректировка кэшбэк-баланса', 'cashback_adjustment — manual cashback balance adjustment'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Скидки (discount-карты)', 'Discounts (discount cards)'),
          items: [
            tr(lang, 'discount_purchase — покупка по скидочной карте (фиксирует сумму для прогрессивной скидки)', 'discount_purchase — purchase with discount card (records amount for progressive discount)'),
            tr(lang, 'discount_adjustment — ручная корректировка скидки', 'discount_adjustment — manual discount adjustment'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Сертификаты', 'Certificates'),
          items: [
            tr(lang, 'certificate_spend — списание с сертификата', 'certificate_spend — certificate spend'),
            tr(lang, 'certificate_adjustment — корректировка баланса сертификата', 'certificate_adjustment — certificate balance adjustment'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Универсальные', 'Universal'),
          items: [
            tr(lang, 'purchase — покупка (универсальное событие, amount = сумма чека)', 'purchase — purchase (universal event, amount = receipt total)'),
            tr(lang, 'writeoff — универсальное списание бонусов (points_issued отрицательный)', 'writeoff — universal bonus write-off (points_issued is negative)'),
            tr(lang, 'api_adjustment — автоматическая транзакция при изменении карточки через PUT /api/v1/client-cards/{uuid}', 'api_adjustment — auto transaction when updating client card via PUT /api/v1/client-cards/{uuid}'),
            tr(lang, 'review_bonus_auto — автоначисление бонусов за отзыв', 'review_bonus_auto — auto bonus for review'),
            tr(lang, 'review_bonus_manual — ручное начисление бонусов за отзыв', 'review_bonus_manual — manual bonus for review'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Через API (POST /api/v1/transactions) можно передать любое значение event. Рекомендуется использовать стандартные значения из списка выше для корректной аналитики и работы интерфейса.',
            'Via API (POST /api/v1/transactions) you can pass any event value. Using standard values from the list above is recommended for correct analytics and UI.',
          ),
        },
      ],
    },
    {
      id: 'public-api-v1-scopes',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Концепции', 'Concepts'),
      navSubgroupOrder: 1,
      navOrder: 40,
      navLabel: tr(lang, 'Scopes (права доступа)', 'Scopes (permissions)'),
      title: tr(lang, 'Полный список scopes', 'Full scopes list'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'При создании API ключа вы указываете набор scopes — гранулярных прав доступа. Каждый эндпоинт проверяет наличие нужного scope. Если scope недостаточно — вернётся 403.',
            'When creating an API key you specify a set of scopes — granular permissions. Each endpoint checks for the required scope. If scope is insufficient — 403 is returned.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Доступные scopes', 'Available scopes'),
          items: [
            tr(lang, 'organization:read — чтение данных организации (GET /api/v1/organization)', 'organization:read — read organization data (GET /api/v1/organization)'),
            tr(lang, 'cards:read — чтение списка карт и карты по UUID', 'cards:read — read card list and card by UUID'),
            tr(lang, 'cards:write — создание, обновление, удаление карт (POST/PUT/DELETE /api/v1/cards)', 'cards:write — create, update, delete cards (POST/PUT/DELETE /api/v1/cards)'),
            tr(lang, 'clients:read — чтение списка клиентов и клиента по UUID', 'clients:read — read client list and client by UUID'),
            tr(lang, 'clients:write — создание, обновление, удаление клиентов (POST/PUT/DELETE /api/v1/clients)', 'clients:write — create, update, delete clients (POST/PUT/DELETE /api/v1/clients)'),
            tr(lang, 'client_cards:read — чтение списка карточек клиентов и карточки по UUID', 'client_cards:read — read client card list and client card by UUID'),
            tr(lang, 'client_cards:write — выпуск карты клиенту, обновление баланса карточки (POST/PUT /api/v1/client-cards)', 'client_cards:write — issue card to client, update client card balance (POST/PUT /api/v1/client-cards)'),
            tr(lang, 'transactions:read — чтение списка транзакций', 'transactions:read — read transaction list'),
            tr(lang, 'transactions:write — создание и удаление транзакций (POST/DELETE /api/v1/transactions)', 'transactions:write — create and delete transactions (POST/DELETE /api/v1/transactions)'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'По умолчанию при создании ключа без указания scopes назначаются: organization:read, cards:read, clients:read, client_cards:read, transactions:read (только чтение).',
            'By default, when creating a key without specifying scopes, the following are assigned: organization:read, cards:read, clients:read, client_cards:read, transactions:read (read-only).',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: ключ с полными правами', 'Example: key with full permissions'),
          key: 'v1-scopes-full',
          value: `{\n  "name": "Full access key",\n  "scopes": [\n    "organization:read",\n    "cards:read", "cards:write",\n    "clients:read", "clients:write",\n    "client_cards:read", "client_cards:write",\n    "transactions:read", "transactions:write"\n  ]\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: ключ только для чтения', 'Example: read-only key'),
          key: 'v1-scopes-readonly',
          value: `{\n  "name": "Analytics key",\n  "scopes": [\n    "organization:read",\n    "cards:read",\n    "clients:read",\n    "client_cards:read",\n    "transactions:read"\n  ]\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-rate-limit',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Концепции', 'Concepts'),
      navSubgroupOrder: 1,
      navOrder: 50,
      navLabel: tr(lang, 'Rate limit', 'Rate limit'),
      title: tr(lang, 'Ограничение частоты запросов (Rate limit)', 'Rate limiting'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Все эндпоинты /api/v1 защищены принудительным ограничением частоты запросов (rate limit). Это не рекомендация — сервер жёстко отклоняет запросы при превышении лимита.',
            'All /api/v1 endpoints are protected by an enforced rate limit. This is not a recommendation — the server strictly rejects requests when the limit is exceeded.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Параметры', 'Parameters'),
          items: [
            tr(lang, 'Лимит: 120 запросов за 60 секунд (скользящее окно)', 'Limit: 120 requests per 60 seconds (sliding window)'),
            tr(lang, 'Группировка: по API ключу (organization_id) или по IP-адресу (для Bearer-токенов)', 'Grouping: by API key (organization_id) or by IP address (for Bearer tokens)'),
            tr(lang, 'При превышении: HTTP 429 Too Many Requests с заголовком Retry-After: 60', 'On exceed: HTTP 429 Too Many Requests with Retry-After: 60 header'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа 429', 'Example 429 response'),
          key: 'v1-rate-limit-429',
          value: `HTTP/1.1 429 Too Many Requests\nRetry-After: 60\nContent-Type: application/json\n\n{\n  "detail": "Too many requests"\n}`,
        },
        {
          type: 'list',
          title: tr(lang, 'Рекомендации', 'Recommendations'),
          items: [
            tr(lang, 'Не превышайте 2 запроса в секунду для стабильной работы', 'Stay under 2 requests per second for stable operation'),
            tr(lang, 'При получении 429 — подождите время из Retry-After и повторите', 'On 429 — wait for Retry-After value and retry'),
            tr(lang, 'Используйте пагинацию (limit/offset) вместо множества мелких запросов', 'Use pagination (limit/offset) instead of many small requests'),
          ],
        },
      ],
    },
    {
      id: 'public-api-v1-bonus-lifetime',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Концепции', 'Concepts'),
      navSubgroupOrder: 1,
      navOrder: 60,
      navLabel: tr(lang, 'Срок жизни бонусов', 'Bonus lifetime'),
      title: tr(lang, 'Срок жизни бонусов и штампов', 'Bonus and stamp lifetime'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Штампы и кэшбэк-бонусы могут иметь ограниченный срок жизни. Если клиент не совершает операций в течение заданного времени — накопления сгорают автоматически. Это настраивается в параметрах карты.',
            'Stamps and cashback bonuses can have a limited lifetime. If a customer doesn\'t perform operations within the configured time — accumulated bonuses expire automatically. This is configured in card settings.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Сгорание штампов (stamp-карты)', 'Stamp expiration (stamp cards)'),
          items: [
            tr(lang, 'Настройка: card.settings.stampLimit = "stampFixedLater"', 'Setting: card.settings.stampLimit = "stampFixedLater"'),
            tr(lang, 'Срок: card.settings.stampDuration = { "value": N, "unit": "days" | "months" | "years" }', 'Duration: card.settings.stampDuration = { "value": N, "unit": "days" | "months" | "years" }'),
            tr(lang, 'Отсчёт от поля last_accrual карточки клиента (дата последнего начисления)', 'Countdown from client card last_accrual field (last accrual date)'),
            tr(lang, 'При сгорании: stamps и active_storage обнуляются', 'On expiration: stamps and active_storage reset to 0'),
            tr(lang, 'Если stampLimit не установлен — штампы не сгорают', 'If stampLimit is not set — stamps do not expire'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Сгорание кэшбэка (cashback-карты)', 'Cashback expiration (cashback cards)'),
          items: [
            tr(lang, 'Настройка: card.settings.cashbackLifetimeDays = N (количество дней)', 'Setting: card.settings.cashbackLifetimeDays = N (number of days)'),
            tr(lang, 'Отсчёт от поля last_accrual карточки клиента', 'Countdown from client card last_accrual field'),
            tr(lang, 'При сгорании: cashback_balance обнуляется', 'On expiration: cashback_balance resets to 0'),
            tr(lang, 'Если cashbackLifetimeDays = 0 или не установлен — бонусы не сгорают', 'If cashbackLifetimeDays = 0 or not set — bonuses do not expire'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Как это работает', 'How it works'),
          items: [
            tr(lang, 'Фоновый процесс проверяет все карточки каждый час', 'Background process checks all cards every hour'),
            tr(lang, 'Проверка также происходит при обращении к карточке через API', 'Check also happens when accessing a card via API'),
            tr(lang, 'last_accrual обновляется автоматически при POST /api/v1/transactions (если gifts_given > 0 или points_issued > 0)', 'last_accrual is updated automatically on POST /api/v1/transactions (if gifts_given > 0 or points_issued > 0)'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Важно для интеграторов: если ваши клиенты долго не совершают покупок, их штампы/бонусы могут сгореть. Рекомендуется информировать клиентов о сроках жизни бонусов в вашем приложении.',
            'Important for integrators: if your customers don\'t make purchases for a long time, their stamps/bonuses may expire. It\'s recommended to inform customers about bonus lifetime in your application.',
          ),
        },
      ],
    },
    {
      id: 'public-api-v1-me',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Общее', 'General'),
      navSubgroupOrder: 0,
      navOrder: 10,
      navLabel: tr(lang, 'Текущий пользователь', 'Current user'),
      title: 'GET /api/v1/me',
      blocks: [
        { type: 'text', value: tr(lang, 'Информация о текущем пользователе.', 'Current user info.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '401 — проверьте токен в Authorization заголовке', '401 — check token in Authorization header'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-me',
          value: `curl -X GET "${api.publicV1}/me" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-me-resp',
          value: `{\n  "id": 1,\n  "uuid": "user-uuid",\n  "email": "user@example.com",\n  "name": "Ivan",\n  "surname": "Ivanov",\n  "role": "owner",\n  "organization_id": 10\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-organization',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Общее', 'General'),
      navSubgroupOrder: 0,
      navOrder: 20,
      navLabel: tr(lang, 'Организация', 'Organization'),
      title: 'GET /api/v1/organization',
      blocks: [
        { type: 'text', value: tr(lang, 'Данные вашей организации.', 'Your organization details.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '401 — проверьте Authorization заголовок или X-Api-Key', '401 — check Authorization header or X-Api-Key'),
            tr(lang, '403 — недостаточно прав или нет организации у пользователя', '403 — insufficient permissions or user has no organization'),
            tr(lang, '404 — организация не найдена', '404 — organization not found'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-org',
          value: `curl -X GET "${api.publicV1}/organization" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-org-resp',
          value: `{\n  "id": 10,\n  "uuid": "org-uuid",\n  "name": "My company",\n  "inn": null,\n  "ogrn": null,\n  "kpp": null,\n  "address": null,\n  "is_active": true\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-cards-list',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Карты', 'Cards'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Список карт организации', 'Organization cards list'),
      title: 'GET /api/v1/cards',
      blocks: [
        { type: 'text', value: tr(lang, 'Список карт (шаблонов программ лояльности) вашей организации. Используйте GET для получения UUID существующих карт — он понадобится для выпуска карточки клиенту.', 'List of cards (loyalty program templates) for your organization. Use GET to retrieve UUIDs of existing cards — you will need them to issue a client card.') },
        {
          type: 'text',
          value: tr(
            lang,
            '⚠ Важно: шаблоны карт (Card) создаются и полностью настраиваются в панели управления Loyal Club (дизайн, порог штампов, авто-награды, сроки жизни бонусов). API-методы POST/PUT для карт позволяют задать только базовые поля (name, status, cashback_percent). Для полноценной работы штамповых и кэшбэк-карт используйте шаблоны, созданные через панель.',
            '⚠ Important: card templates (Card) are created and fully configured in the Loyal Club admin panel (design, stamp threshold, auto-rewards, bonus lifetime). API POST/PUT methods for cards only set basic fields (name, status, cashback_percent). For full stamp and cashback card functionality, use templates created in the admin panel.',
          ),
        },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Параметры запроса', 'Query params'),
          items: ['limit (int, 1..200)', 'offset (int, >=0)'],
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '401 — проверьте токен/ключ', '401 — check token/api key'),
            tr(lang, '403 — недостаточно scope у API ключа', '403 — insufficient API key scope'),
            tr(lang, '422 — проверьте обязательные поля (например name)', '422 — validate required fields (e.g., name)'),
            tr(lang, '409 — удаление невозможно из-за связанных данных', '409 — delete is blocked by related data'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Методы записи', 'Write endpoints'),
          items: ['POST /api/v1/cards', 'PUT /api/v1/cards/{uuid}', 'DELETE /api/v1/cards/{uuid}'],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'GET /api/v1/cards возвращает список карт вашей организации с поддержкой пагинации.',
            'GET /api/v1/cards returns a paginated list of your organization cards.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-cards',
          value: `curl -X GET "${api.publicV1}/cards?limit=50&offset=0" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-cards-resp',
          value: `{\n  "items": [\n    {\n      "id": 1,\n      "uuid": "card-uuid",\n      "name": "Main card",\n      "status": "Активна",\n      "is_active": true,\n      "is_template": false,\n      "cashback_percent": 5,\n      "discount_percent": 0\n    }\n  ],\n  "total": 1,\n  "limit": 50,\n  "offset": 0\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'POST /api/v1/cards создаёт карту с базовыми полями. Для большинства интеграций создавать карты через API не нужно — используйте шаблоны, настроенные в панели управления Loyal Club. Метод полезен для простых сценариев (скидочные карты) или автоматизации.',
            'POST /api/v1/cards creates a card with basic fields. For most integrations you do not need to create cards via API — use templates configured in the Loyal Club admin panel. This method is useful for simple scenarios (discount cards) or automation.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: создать карту', 'Example: create card'),
          key: 'v1-cards-create-inline',
          value: `curl -X POST "${api.publicV1}/cards" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "name": "Main card",\n    "status": "cashback",\n    "is_active": true,\n    "cashback_percent": 5,\n    "discount_percent": 0\n  }'`,
        },
        {
          type: 'list',
          title: tr(lang, 'POST /api/v1/cards — поля запроса', 'POST /api/v1/cards — request fields'),
          items: [
            tr(lang, 'name (string, обязательно) — название карты', 'name (string, required) — card name'),
            tr(lang, 'status (string, опционально) — тип карты: stamp, cashback, discount, subscription, certificate (по умолчанию "Активна")', 'status (string, optional) — card type: stamp, cashback, discount, subscription, certificate (default "Активна")'),
            tr(lang, 'is_active (boolean, опционально, по умолчанию true)', 'is_active (boolean, optional, default true)'),
            tr(lang, 'is_template (boolean, опционально, по умолчанию false)', 'is_template (boolean, optional, default false)'),
            tr(lang, 'cashback_percent (int, опционально, по умолчанию 0)', 'cashback_percent (int, optional, default 0)'),
            tr(lang, 'discount_percent (int, опционально, по умолчанию 0)', 'discount_percent (int, optional, default 0)'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа POST /api/v1/cards', 'Example response POST /api/v1/cards'),
          key: 'v1-cards-create-resp',
          value: `{\n  "id": 42,\n  "uuid": "a1b2c3d4-e5f6-...",\n  "name": "Main card",\n  "status": "cashback",\n  "is_active": true,\n  "is_template": false,\n  "cashback_percent": 5,\n  "discount_percent": 0\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'PUT /api/v1/cards/{uuid} обновляет существующую карту: название, активность, проценты и другие поддерживаемые поля.',
            'PUT /api/v1/cards/{uuid} updates an existing card: name, active flag, percentages, and other supported fields.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: обновить карту', 'Example: update card'),
          key: 'v1-cards-update-inline-full',
          value: `curl -X PUT "${api.publicV1}/cards/<CARD_UUID>" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "name": "Main card v2",\n    "cashback_percent": 7,\n    "is_pinned": true\n  }'`,
        },
        {
          type: 'list',
          title: tr(lang, 'PUT /api/v1/cards/{uuid} — поля запроса', 'PUT /api/v1/cards/{uuid} — request fields'),
          items: [
            tr(lang, 'Все поля опциональны: name, status, is_active, is_template, cashback_percent, discount_percent, is_pinned', 'All fields are optional: name, status, is_active, is_template, cashback_percent, discount_percent, is_pinned'),
            tr(lang, 'name, если передан, не может быть пустой строкой', 'name, if provided, cannot be an empty string'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'DELETE /api/v1/cards/{uuid} удаляет карту. Метод полезен для очистки тестовых или неиспользуемых карт.',
            'DELETE /api/v1/cards/{uuid} removes a card. Useful for cleaning up test or unused cards.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа PUT /api/v1/cards/{uuid}', 'Example response PUT /api/v1/cards/{uuid}'),
          key: 'v1-cards-update-resp',
          value: `{\n  "id": 42,\n  "uuid": "a1b2c3d4-e5f6-...",\n  "name": "Main card v2",\n  "status": "cashback",\n  "is_active": true,\n  "is_template": false,\n  "cashback_percent": 7,\n  "discount_percent": 0\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: удалить карту', 'Example: delete card'),
          key: 'v1-cards-delete-inline-full',
          value: `curl -X DELETE "${api.publicV1}/cards/<CARD_UUID>" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа DELETE /api/v1/cards/{uuid}', 'Example response DELETE /api/v1/cards/{uuid}'),
          key: 'v1-cards-delete-resp',
          value: `{\n  "success": true\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-cards-get',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Карты', 'Cards'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Карта по UUID', 'Card by UUID'),
      title: 'GET /api/v1/cards/{uuid}',
      blocks: [
        { type: 'text', value: tr(lang, 'Карта по UUID.', 'Card by UUID.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['uuid (string)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '404 — проверьте UUID карты и принадлежность к вашей организации', '404 — check card UUID and organization ownership'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-card',
          value: `curl -X GET "${api.publicV1}/cards/<CARD_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-card-resp',
          value: `{\n  "id": 1,\n  "uuid": "card-uuid",\n  "name": "Main card",\n  "status": "Активна",\n  "is_active": true,\n  "is_template": false,\n  "cashback_percent": 5,\n  "discount_percent": 0\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-clients-list',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Клиенты', 'Clients'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'Список клиентов', 'Clients list'),
      title: 'GET /api/v1/clients',
      blocks: [
        { type: 'text', value: tr(lang, 'Список клиентов.', 'List of clients.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Параметры запроса', 'Query params'),
          items: ['limit (int, 1..200)', 'offset (int, >=0)', tr(lang, 'q (string) — поиск по телефону, email, имени или фамилии (частичное совпадение)', 'q (string) — search by phone, email, name or surname (partial match)')],
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '403 — недостаточно scope у API ключа', '403 — insufficient API key scope'),
            tr(lang, '422 — для создания нужен минимум один идентификатор клиента', '422 — create requires at least one customer identifier'),
            tr(lang, '409 — удаление невозможно из-за связанных данных', '409 — delete is blocked by related data'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Методы записи', 'Write endpoints'),
          items: ['POST /api/v1/clients', 'PUT /api/v1/clients/{uuid}', 'DELETE /api/v1/clients/{uuid}'],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'GET /api/v1/clients возвращает список клиентов организации с фильтрами и пагинацией.',
            'GET /api/v1/clients returns a paginated list of organization customers with filters.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-clients',
          value: `curl -X GET "${api.publicV1}/clients?limit=50&offset=0&q=7999" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-clients-resp',
          value: `{\n  "items": [\n    {\n      "id": 100,\n      "uuid": "client-uuid",\n      "name": "Ivan",\n      "surname": "Ivanov",\n      "phone": "+79990001122",\n      "email": "ivanov@example.com",\n      "gender": "male"\n    }\n  ],\n  "total": 1,\n  "limit": 50,\n  "offset": 0\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'POST /api/v1/clients создаёт клиента в вашей организации. После создания клиента можно выпускать ему карты, записывать транзакции и отправлять рассылки.',
            'POST /api/v1/clients creates a customer in your organization. After creation, you can issue cards, record transactions, and send mailings.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: создать клиента', 'Example: create client'),
          key: 'v1-clients-create-inline',
          value: `curl -X POST "${api.publicV1}/clients" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "name": "Ivan",\n    "surname": "Ivanov",\n    "phone": "+79990001122",\n    "email": "ivanov@example.com"\n  }'`,
        },
        {
          type: 'list',
          title: tr(lang, 'POST /api/v1/clients — поля запроса', 'POST /api/v1/clients — request fields'),
          items: [
            tr(lang, 'name (string, опционально)', 'name (string, optional)'),
            tr(lang, 'surname (string, опционально)', 'surname (string, optional)'),
            tr(lang, 'phone (string, опционально)', 'phone (string, optional)'),
            tr(lang, 'email (string, опционально)', 'email (string, optional)'),
            tr(lang, 'gender (string, опционально)', 'gender (string, optional)'),
            tr(lang, 'comment (string, опционально)', 'comment (string, optional)'),
            tr(lang, 'Ограничение: минимум одно из полей name/surname/phone/email должно быть заполнено', 'Constraint: at least one of name/surname/phone/email must be provided'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа POST /api/v1/clients', 'Example response POST /api/v1/clients'),
          key: 'v1-clients-create-resp',
          value: `{\n  "id": 100,\n  "uuid": "b2c3d4e5-f6a7-...",\n  "name": "Ivan",\n  "surname": "Ivanov",\n  "phone": "+79990001122",\n  "email": "ivanov@example.com",\n  "gender": null\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'PUT /api/v1/clients/{uuid} обновляет профиль клиента: контакты, пол и комментарий.',
            'PUT /api/v1/clients/{uuid} updates customer profile fields: contacts, gender, and comment.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: обновить клиента', 'Example: update client'),
          key: 'v1-clients-update-inline-full',
          value: `curl -X PUT "${api.publicV1}/clients/<CLIENT_UUID>" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "phone": "+79990002233",\n    "email": "newmail@example.com",\n    "comment": "VIP клиент"\n  }'`,
        },
        {
          type: 'list',
          title: tr(lang, 'PUT /api/v1/clients/{uuid} — поля запроса', 'PUT /api/v1/clients/{uuid} — request fields'),
          items: [
            tr(lang, 'Все поля опциональны: name, surname, phone, email, gender, comment', 'All fields are optional: name, surname, phone, email, gender, comment'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'DELETE /api/v1/clients/{uuid} удаляет клиента. Используйте для удаления дублей и тестовых записей.',
            'DELETE /api/v1/clients/{uuid} removes a customer. Use it to clean duplicates and test data.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа PUT /api/v1/clients/{uuid}', 'Example response PUT /api/v1/clients/{uuid}'),
          key: 'v1-clients-update-resp',
          value: `{\n  "id": 100,\n  "uuid": "b2c3d4e5-f6a7-...",\n  "name": "Ivan",\n  "surname": "Ivanov",\n  "phone": "+79990002233",\n  "email": "newmail@example.com",\n  "gender": null\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: удалить клиента', 'Example: delete client'),
          key: 'v1-clients-delete-inline-full',
          value: `curl -X DELETE "${api.publicV1}/clients/<CLIENT_UUID>" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа DELETE /api/v1/clients/{uuid}', 'Example response DELETE /api/v1/clients/{uuid}'),
          key: 'v1-clients-delete-resp',
          value: `{\n  "success": true\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-clients-get',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Клиенты', 'Clients'),
      navSubgroupOrder: 20,
      navOrder: 20,
      navLabel: tr(lang, 'Клиент по UUID', 'Client by UUID'),
      title: 'GET /api/v1/clients/{uuid}',
      blocks: [
        { type: 'text', value: tr(lang, 'Клиент по UUID.', 'Client by UUID.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['uuid (string)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '404 — проверьте UUID клиента и принадлежность к вашей организации', '404 — check client UUID and organization ownership'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-client',
          value: `curl -X GET "${api.publicV1}/clients/<CLIENT_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-client-resp',
          value: `{\n  "id": 100,\n  "uuid": "client-uuid",\n  "name": "Ivan",\n  "surname": "Ivanov",\n  "phone": "+79990001122",\n  "email": "ivanov@example.com",\n  "gender": "male"\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-client-cards-list',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Карточки клиента', 'Client cards'),
      navSubgroupOrder: 30,
      navOrder: 10,
      navLabel: tr(lang, 'Список карточек клиента', 'Client cards list'),
      title: 'GET /api/v1/client-cards',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Список карточек клиента (реальные связки карта организации ↔ клиент) с фильтрами по карте и клиенту.',
            'List of client cards (real organization-card ↔ customer links) with card/customer filters.',
          ),
        },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Параметры запроса', 'Query params'),
          items: [
            'limit (int, 1..200)',
            'offset (int, >=0)',
            'card_uuid (string)',
            'client_uuid (string)',
            tr(lang, 'card_number (string) — поиск по номеру карты клиента', 'card_number (string) — search by client card number'),
          ],
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '403 — недостаточно scope у API ключа', '403 — insufficient API key scope'),
            tr(lang, '404 — карта или клиент не найдены', '404 — card or client not found'),
            tr(lang, '409 — карта уже выпущена этому клиенту', '409 — card is already issued to this customer'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Методы записи', 'Write endpoints'),
          items: ['POST /api/v1/client-cards/issue', 'PUT /api/v1/client-cards/{uuid}', 'DELETE /api/v1/client-cards/{uuid}'],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'POST /api/v1/client-cards/issue выпускает карту выбранному клиенту. Возвращает карточку клиента с номером и балансными полями.',
            'POST /api/v1/client-cards/issue issues a card to a selected customer and returns the created client-card object.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'curl — по UUID карты', 'curl — by card UUID'),
          key: 'v1-clientcards',
          value: `curl -X GET "${api.publicV1}/client-cards?limit=50&offset=0&card_uuid=<CARD_UUID>" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'curl — поиск по номеру карты', 'curl — search by card number'),
          key: 'v1-clientcards-by-number',
          value: `curl -X GET "${api.publicV1}/client-cards?card_number=000123" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-clientcards-resp',
          value: `{\n  "items": [\n    {\n      "id": 500,\n      "uuid": "client-card-uuid",\n      "card_number": "000123",\n      "client_id": 100,\n      "client_uuid": "b2c3d4e5-f6a7-...",\n      "card_id": 1,\n      "card_uuid": "a1b2c3d4-e5f6-...",\n      "card_type": "cashback",\n      "stamps": 0,\n      "available_rewards": 0,\n      "cashback_balance": 120,\n      "cashback_percent": 5,\n      "discount_percent": 0,\n      "total_spent": 2400,\n      "wallet_installed": "installed"\n    }\n  ],\n  "total": 1,\n  "limit": 50,\n  "offset": 0\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: выпустить карту клиенту', 'Example: issue client card'),
          key: 'v1-clientcards-issue-inline',
          value: `curl -X POST "${api.publicV1}/client-cards/issue" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "card_uuid": "<CARD_UUID>",\n    "client_uuid": "<CLIENT_UUID>"\n  }'`,
        },
        {
          type: 'list',
          title: tr(lang, 'POST /api/v1/client-cards/issue — поля запроса', 'POST /api/v1/client-cards/issue — request fields'),
          items: [
            tr(lang, 'card_uuid (string, обязательно) — UUID карты', 'card_uuid (string, required) — card UUID'),
            tr(lang, 'client_uuid (string, обязательно) — UUID клиента', 'client_uuid (string, required) — client UUID'),
            tr(lang, 'card_number (string, опционально) — номер карты, если нужно задать вручную (иначе генерируется автоматически)', 'card_number (string, optional) — explicit card number (otherwise auto-generated)'),
            tr(lang, 'Ограничение: одна и та же карта не может быть выпущена одному клиенту повторно (409)', 'Constraint: same card cannot be issued twice to the same customer (409)'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа POST /api/v1/client-cards/issue', 'Example response POST /api/v1/client-cards/issue'),
          key: 'v1-clientcards-issue-resp',
          value: `{\n  "id": 500,\n  "uuid": "c3d4e5f6-a7b8-...",\n  "card_number": "000001",\n  "client_id": 100,\n  "client_uuid": "b2c3d4e5-f6a7-...",\n  "card_id": 42,\n  "card_uuid": "a1b2c3d4-e5f6-...",\n  "card_type": "cashback",\n  "stamps": 0,\n  "available_rewards": 0,\n  "cashback_balance": 0,\n  "cashback_percent": 5,\n  "discount_percent": 0,\n  "total_spent": 0,\n  "wallet_installed": null\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-client-cards-get',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Карточки клиента', 'Client cards'),
      navSubgroupOrder: 30,
      navOrder: 20,
      navLabel: tr(lang, 'Карточка клиента по UUID', 'Client card by UUID'),
      title: 'GET /api/v1/client-cards/{uuid}',
      blocks: [
        { type: 'text', value: tr(lang, 'Карточка клиента по UUID.', 'Client card by UUID.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['uuid (string)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '404 — проверьте UUID карточки клиента и принадлежность к вашей организации', '404 — check client-card UUID and organization ownership'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-clientcard',
          value: `curl -X GET "${api.publicV1}/client-cards/<CLIENT_CARD_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-clientcard-resp',
          value: `{\n  "id": 500,\n  "uuid": "client-card-uuid",\n  "card_number": "000123",\n  "client_id": 100,\n  "client_uuid": "b2c3d4e5-f6a7-...",\n  "card_id": 1,\n  "card_uuid": "a1b2c3d4-e5f6-...",\n  "card_type": "cashback",\n  "stamps": 0,\n  "available_rewards": 0,\n  "cashback_balance": 120,\n  "cashback_percent": 5,\n  "discount_percent": 0,\n  "total_spent": 2400,\n  "wallet_installed": "installed"\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-client-cards-update',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Карточки клиента', 'Client cards'),
      navSubgroupOrder: 30,
      navOrder: 30,
      navLabel: tr(lang, 'Обновить карточку клиента', 'Update client card'),
      title: 'PUT /api/v1/client-cards/{uuid}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Обновляет балансные поля карточки клиента: штампы, кэшбэк-баланс, доступные награды, сумму покупок, проценты. При изменении создаётся транзакция-лог с event "api_adjustment".',
            'Updates client card balance fields: stamps, cashback balance, available rewards, total spent, percentages. A log transaction with event "api_adjustment" is created on change.',
          ),
        },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['uuid (string)'] },
        {
          type: 'list',
          title: tr(lang, 'Коды ответов', 'Response codes'),
          items: [
            tr(lang, '200 — успешно', '200 — success'),
            tr(lang, '401 — не авторизован', '401 — unauthorized'),
            tr(lang, '403 — нет доступа (scope client_cards:write)', '403 — forbidden (scope client_cards:write)'),
            tr(lang, '404 — карточка клиента не найдена', '404 — client card not found'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'PUT /api/v1/client-cards/{uuid} — поля запроса', 'PUT /api/v1/client-cards/{uuid} — request fields'),
          items: [
            tr(lang, 'stamps (int, опционально) — количество штампов (абсолютное значение)', 'stamps (int, optional) — stamp count (absolute value)'),
            tr(lang, 'cashback_balance (int, опционально) — кэшбэк-баланс (абсолютное значение)', 'cashback_balance (int, optional) — cashback balance (absolute value)'),
            tr(lang, 'available_rewards (int, опционально) — доступные награды', 'available_rewards (int, optional) — available rewards'),
            tr(lang, 'total_spent (int, опционально) — общая сумма покупок', 'total_spent (int, optional) — total amount spent'),
            tr(lang, 'cashback_percent (int, опционально) — процент кэшбэка', 'cashback_percent (int, optional) — cashback percent'),
            tr(lang, 'discount_percent (int, опционально) — процент скидки', 'discount_percent (int, optional) — discount percent'),
            tr(lang, 'Все значения не могут быть отрицательными (min 0)', 'All values cannot be negative (min 0)'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: обновить баланс карточки', 'Example: update client card balance'),
          key: 'v1-clientcards-update-inline',
          value: `curl -X PUT "${api.publicV1}/client-cards/<CLIENT_CARD_UUID>" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "stamps": 5,\n    "cashback_balance": 500,\n    "total_spent": 10000\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-clientcards-update-resp',
          value: `{\n  "id": 500,\n  "uuid": "client-card-uuid",\n  "card_number": "000123",\n  "client_id": 100,\n  "client_uuid": "b2c3d4e5-f6a7-...",\n  "card_id": 1,\n  "card_uuid": "a1b2c3d4-e5f6-...",\n  "card_type": "cashback",\n  "stamps": 5,\n  "available_rewards": 0,\n  "cashback_balance": 500,\n  "cashback_percent": 5,\n  "discount_percent": 0,\n  "total_spent": 10000,\n  "wallet_installed": "installed"\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-client-cards-delete',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Карточки клиента', 'Client cards'),
      navSubgroupOrder: 30,
      navOrder: 40,
      navLabel: tr(lang, 'Удалить карточку клиента', 'Delete client card'),
      title: 'DELETE /api/v1/client-cards/{uuid}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Удаляет (открепляет) карточку от клиента. Связанные транзакции могут заблокировать удаление (409).',
            'Deletes (unlinks) a client card. Related transactions may block deletion (409).',
          ),
        },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>', 'X-Api-Key: <API_KEY>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['uuid (string)'] },
        {
          type: 'list',
          title: tr(lang, 'Коды ответов', 'Response codes'),
          items: [
            tr(lang, '200 — успешно', '200 — success'),
            tr(lang, '401 — не авторизован', '401 — unauthorized'),
            tr(lang, '403 — нет доступа (scope client_cards:write)', '403 — forbidden (scope client_cards:write)'),
            tr(lang, '404 — карточка клиента не найдена', '404 — client card not found'),
            tr(lang, '409 — нельзя удалить из-за связанных транзакций', '409 — cannot delete due to related transactions'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-clientcards-delete',
          value: `curl -X DELETE "${api.publicV1}/client-cards/<CLIENT_CARD_UUID>" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-clientcards-delete-resp',
          value: `{\n  "success": true\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-transactions-list',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Транзакции', 'Transactions'),
      navSubgroupOrder: 40,
      navOrder: 10,
      navLabel: tr(lang, 'Список транзакций', 'Transactions list'),
      title: 'GET /api/v1/transactions',
      blocks: [
        { type: 'text', value: tr(lang, 'Список транзакций.', 'List of transactions.') },
        { type: 'text', value: tr(lang, `Базовый URL: ${api.publicV1}`, `Base URL: ${api.publicV1}`) },
        {
          type: 'list',
          title: tr(lang, 'Заголовки', 'Headers'),
          items: [
            'Authorization: Bearer <USER_TOKEN>',
            'X-Api-Key: <API_KEY>',
            tr(lang, 'Idempotency-Key: <UNIQUE_KEY> (рекомендуется для POST)', 'Idempotency-Key: <UNIQUE_KEY> (recommended for POST)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Параметры запроса', 'Query params'),
          items: [
            'limit (int, 1..200)',
            'offset (int, >=0)',
            'card_uuid (string)',
            'client_uuid (string)',
            'event (string)',
            'date_from (ISO 8601)',
            'date_to (ISO 8601)',
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Формат date_from/date_to: ISO 8601 (например 2026-02-12T00:00:00Z).',
            'date_from/date_to format: ISO 8601 (e.g. 2026-02-12T00:00:00Z).',
          ),
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '422 — ошибка валидации', '422 — validation error')] },
        {
          type: 'list',
          title: tr(lang, 'Типовые ошибки и что делать', 'Common errors and what to do'),
          items: [
            tr(lang, '422 — проверьте формат date_from/date_to (ISO 8601) и обязательный event при создании', '422 — validate date_from/date_to format (ISO 8601) and required event on create'),
            tr(lang, '404 — карта/клиент/транзакция не найдены', '404 — card/client/transaction not found'),
            tr(lang, '403 — недостаточно scope у API ключа', '403 — insufficient API key scope'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Методы записи', 'Write endpoints'),
          items: ['POST /api/v1/transactions', 'DELETE /api/v1/transactions/{transaction_id}'],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'GET /api/v1/transactions возвращает список транзакций с фильтрами по карте, клиенту, типу события и периоду.',
            'GET /api/v1/transactions returns a filtered transaction list by card, customer, event, and period.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-tx',
          value: `curl -X GET "${api.publicV1}/transactions?limit=50&offset=0&card_uuid=<CARD_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'v1-tx-resp',
          value: `{\n  "items": [\n    {\n      "id": 900,\n      "date_time": "2026-02-12T10:15:00+00:00",\n      "event": "purchase",\n      "quantity": "1",\n      "balance": "120",\n      "amount": 2400,\n      "points_issued": 0,\n      "gifts_given": 0,\n      "client_id": 100,\n      "client_uuid": "client-uuid",\n      "card_id": 1,\n      "card_uuid": "card-uuid"\n    }\n  ],\n  "total": 1,\n  "limit": 50,\n  "offset": 0\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'POST /api/v1/transactions создаёт операцию по карте клиента и обновляет баланс карточки: cashback_balance += points_issued, total_spent += amount, stamps += gifts_given. Для штамповых карт (status = "stamp") при достижении порога (stampsQuantity из настроек карты) автоматически начисляется награда и штампы обнуляются.',
            'POST /api/v1/transactions creates a client-card operation and updates the card balance: cashback_balance += points_issued, total_spent += amount, stamps += gifts_given. For stamp cards (status = "stamp") when threshold is reached (stampsQuantity from card settings), a reward is automatically granted and stamps are reset.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: создать транзакцию', 'Example: create transaction'),
          key: 'v1-tx-create-inline',
          value: `curl -X POST "${api.publicV1}/transactions" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "card_uuid": "<CARD_UUID>",\n    "client_uuid": "<CLIENT_UUID>",\n    "event": "purchase",\n    "amount": 2400,\n    "points_issued": 120\n  }'`,
        },
        {
          type: 'list',
          title: tr(lang, 'POST /api/v1/transactions — поля запроса', 'POST /api/v1/transactions — request fields'),
          items: [
            tr(lang, 'card_uuid (string, обязательно) — UUID карты организации', 'card_uuid (string, required) — organization card UUID'),
            tr(lang, 'client_uuid (string, обязательно) — UUID клиента', 'client_uuid (string, required) — client UUID'),
            tr(lang, 'event (string, обязательно) — тип события (см. "Типы событий")', 'event (string, required) — event type (see "Event types")'),
            tr(lang, 'amount (int, опционально, по умолчанию 0) — сумма чека / покупки', 'amount (int, optional, default 0) — receipt / purchase amount'),
            tr(
              lang,
              'points_issued (int, опционально, по умолчанию 0) — бонусы: положительное начисляет (cashback_balance +=), отрицательное списывает (cashback_balance -=)',
              'points_issued (int, optional, default 0) — bonuses: positive accrues (cashback_balance +=), negative writes off (cashback_balance -=)',
            ),
            tr(lang, 'gifts_given (int, опционально, по умолчанию 0) — штампы: положительное добавляет (stamps +=), отрицательное убирает', 'gifts_given (int, optional, default 0) — stamps: positive adds (stamps +=), negative removes'),
            tr(lang, 'quantity (string, опционально) — количество товаров', 'quantity (string, optional) — item count'),
            tr(lang, 'balance (string, опционально) — информационное поле', 'balance (string, optional) — informational field'),
            tr(lang, 'phone (string, опционально) — телефон клиента (перезапись)', 'phone (string, optional) — client phone (override)'),
            tr(lang, 'device (string, опционально) — устройство/источник', 'device (string, optional) — device/source'),
            tr(lang, 'template (string, опционально) — шаблон', 'template (string, optional) — template'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Важно: для создания транзакции у клиента должна быть выпущена эта карта. Если нет — вернётся 404 с подсказкой.',
            'Important: the client must have this card issued to create a transaction. If not — 404 is returned with a hint.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа POST /api/v1/transactions', 'Example response POST /api/v1/transactions'),
          key: 'v1-tx-create-resp',
          value: `{\n  "id": 900,\n  "date_time": "2026-02-25T14:30:00+00:00",\n  "event": "purchase",\n  "quantity": null,\n  "balance": "120",\n  "amount": 2400,\n  "points_issued": 120,\n  "gifts_given": 0,\n  "client_id": 100,\n  "client_uuid": "b2c3d4e5-f6a7-...",\n  "card_id": 42,\n  "card_uuid": "a1b2c3d4-e5f6-...",\n  "reward_given": false,\n  "reward_received": false\n}`,
        },
        {
          type: 'list',
          title: tr(lang, 'Авто-награды для штамповых карт', 'Auto-rewards for stamp cards'),
          items: [
            tr(lang, 'При gifts_given > 0 для карт с status = "stamp": если после начисления stamps >= stampsQuantity (из card.design, по умолчанию 10) — автоматически начисляется награда', 'When gifts_given > 0 for cards with status = "stamp": if after accrual stamps >= stampsQuantity (from card.design, default 10) — reward is automatically granted'),
            tr(lang, 'При начислении награды: stamps обнуляется, available_rewards += 1, создаётся транзакция reward_given', 'On reward grant: stamps resets to 0, available_rewards += 1, reward_given transaction is created'),
            tr(lang, 'Если в настройках карты включён autoRedeem: награда сразу вручается (available_rewards -= 1, создаётся reward_received)', 'If autoRedeem is enabled in card settings: reward is immediately redeemed (available_rewards -= 1, reward_received transaction is created)'),
            tr(lang, 'В ответе POST /api/v1/transactions поля reward_given и reward_received показывают, произошло ли это', 'In POST /api/v1/transactions response, reward_given and reward_received fields indicate if this happened'),
            tr(lang, 'last_accrual обновляется при каждом начислении штампов или бонусов (важно для сроков жизни)', 'last_accrual is updated on each stamp/bonus accrual (important for bonus lifetime)'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'DELETE /api/v1/transactions/{transaction_id} удаляет транзакцию и откатывает изменения баланса карточки (cashback_balance, total_spent, stamps).',
            'DELETE /api/v1/transactions/{transaction_id} removes a transaction and rolls back balance changes (cashback_balance, total_spent, stamps).',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример: удалить транзакцию', 'Example: delete transaction'),
          key: 'v1-tx-delete-inline',
          value: `curl -X DELETE "${api.publicV1}/transactions/<TRANSACTION_ID>" \\\n  -H "X-Api-Key: <API_KEY>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа DELETE /api/v1/transactions/{id}', 'Example response DELETE /api/v1/transactions/{id}'),
          key: 'v1-tx-delete-resp',
          value: `{\n  "success": true\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-integration-playbook',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 10,
      navLabel: tr(lang, 'Пошаговый сценарий', 'Step-by-step playbook'),
      title: tr(lang, 'Пошаговый сценарий интеграции', 'Step-by-step integration playbook'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Предусловия (в панели управления Loyal Club)', 'Prerequisites (in Loyal Club admin panel)'),
          items: [
            tr(lang, 'Создайте шаблон карты лояльности: Карты → Создать карту (настройте тип, дизайн, пороги штампов, кэшбэк и т.д.)', 'Create a loyalty card template: Cards → Create card (set type, design, stamp thresholds, cashback, etc.)'),
            tr(lang, 'Создайте API ключ: Профиль → Персональные настройки → API ключи. Укажите нужные scopes (clients:write, client_cards:write, transactions:write и др.)', 'Create an API key: Profile → Personal settings → API keys. Set required scopes (clients:write, client_cards:write, transactions:write, etc.)'),
            tr(lang, 'Скопируйте API ключ — он показывается полностью только один раз', 'Copy the API key — it is shown in full only once'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Шаги интеграции', 'Integration steps'),
          items: [
            tr(lang, '1) Проверьте доступ: GET /api/v1/organization', '1) Verify access: GET /api/v1/organization'),
            tr(lang, '2) Получите UUID вашего шаблона карты: GET /api/v1/cards — найдите нужную карту и сохраните её uuid', '2) Get your card template UUID: GET /api/v1/cards — find the desired card and save its uuid'),
            tr(lang, '3) Найдите клиента по телефону: GET /api/v1/clients?q=+7999... или создайте нового: POST /api/v1/clients', '3) Find customer by phone: GET /api/v1/clients?q=+7999... or create a new one: POST /api/v1/clients'),
            tr(lang, '4) Выпустите карту клиенту: POST /api/v1/client-cards/issue (card_uuid + client_uuid)', '4) Issue card to customer: POST /api/v1/client-cards/issue (card_uuid + client_uuid)'),
            tr(lang, '5) Запишите операцию (начисление/списание): POST /api/v1/transactions — баланс карточки обновится автоматически', '5) Record operation (accrual/write-off): POST /api/v1/transactions — card balance updates automatically'),
            tr(lang, '6) Проверьте результат: GET /api/v1/client-cards?client_uuid=... (баланс) и GET /api/v1/transactions?client_uuid=... (история)', '6) Verify result: GET /api/v1/client-cards?client_uuid=... (balance) and GET /api/v1/transactions?client_uuid=... (history)'),
            tr(lang, '7) (Опционально) Обновите карточку напрямую: PUT /api/v1/client-cards/{uuid}', '7) (Optional) Update card directly: PUT /api/v1/client-cards/{uuid}'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Минимальная последовательность curl', 'Minimal curl sequence'),
          key: 'v1-playbook-sequence',
          value: `# 1) проверка доступа\ncurl -X GET "${api.publicV1}/organization" \\\n  -H "X-Api-Key: <API_KEY>"\n\n# 2) получить UUID шаблона карты\ncurl -X GET "${api.publicV1}/cards?limit=10&offset=0" \\\n  -H "X-Api-Key: <API_KEY>"\n\n# 3) найти клиента по телефону\ncurl -X GET "${api.publicV1}/clients?q=%2B79990001122" \\\n  -H "X-Api-Key: <API_KEY>"\n\n# 3б) или создать нового клиента\ncurl -X POST "${api.publicV1}/clients" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "name": "Ivan",\n    "phone": "+79990001122"\n  }'\n\n# 4) выпустить карту клиенту\ncurl -X POST "${api.publicV1}/client-cards/issue" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "card_uuid": "<CARD_UUID>",\n    "client_uuid": "<CLIENT_UUID>"\n  }'\n\n# 5) начислить бонусы (cashback_balance += 120, total_spent += 2400)\ncurl -X POST "${api.publicV1}/transactions" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "card_uuid": "<CARD_UUID>",\n    "client_uuid": "<CLIENT_UUID>",\n    "event": "purchase",\n    "amount": 2400,\n    "points_issued": 120\n  }'\n\n# 6) проверить баланс карточки\ncurl -X GET "${api.publicV1}/client-cards?client_uuid=<CLIENT_UUID>&limit=1&offset=0" \\\n  -H "X-Api-Key: <API_KEY>"\n\n# 7) списать бонусы (cashback_balance -= 100)\ncurl -X POST "${api.publicV1}/transactions" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "card_uuid": "<CARD_UUID>",\n    "client_uuid": "<CLIENT_UUID>",\n    "event": "writeoff",\n    "amount": 0,\n    "points_issued": -100\n  }'\n\n# 8) или обновить карточку напрямую\ncurl -X PUT "${api.publicV1}/client-cards/<CLIENT_CARD_UUID>" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "stamps": 3,\n    "cashback_balance": 500\n  }'`,
        },
      ],
    },
    {
      id: 'public-api-v1-error-format',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 20,
      navLabel: tr(lang, 'Формат ошибок', 'Error format'),
      title: tr(lang, 'Формат ошибок и нормализация', 'Error format and normalization'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Фактический формат ошибок API сейчас возвращается в поле detail. Для валидационных ошибок detail — массив объектов FastAPI.',
            'Current API error payload is returned in detail field. For validation errors detail is an array of FastAPI error objects.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Фактический 404', 'Actual 404'),
          key: 'v1-err-404',
          value: `{\n  "detail": "Клиент не найден"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Фактический 422', 'Actual 422'),
          key: 'v1-err-422',
          value: `{\n  "detail": [\n    {\n      "loc": ["body", "event"],\n      "msg": "Field required",\n      "type": "missing"\n    }\n  ]\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Рекомендуемая унификация на стороне интегратора (adapter layer): приводите ответ к структуре detail/code/fields.',
            'Recommended integrator-side normalization (adapter layer): convert API errors to detail/code/fields structure.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Рекомендуемый унифицированный формат', 'Recommended normalized format'),
          key: 'v1-err-normalized',
          value: `{\n  "detail": "Клиент не найден",\n  "code": "CLIENT_NOT_FOUND",\n  "fields": []\n}`,
        },
      ],
    },
    {
      id: 'public-api-v1-operations',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 30,
      navLabel: tr(lang, 'Операционные правила', 'Operational rules'),
      title: tr(lang, 'Операционные правила интеграции', 'Operational integration rules'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Rate limit (принудительный)', 'Rate limit (enforced)'),
          items: [
            tr(lang, 'Жёсткий лимит: 120 запросов / 60 секунд на организацию (скользящее окно)', 'Hard limit: 120 requests / 60 seconds per organization (sliding window)'),
            tr(lang, 'При превышении — HTTP 429 с заголовком Retry-After: 60', 'On exceed — HTTP 429 with Retry-After: 60 header'),
            tr(lang, 'Рекомендуем не превышать 2 запроса/сек для стабильной работы', 'Recommended: stay under 2 req/sec for stability'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Таймауты клиента', 'Client timeouts'),
          items: [
            tr(lang, 'GET-запросы: таймаут 10 секунд', 'GET requests: 10 second timeout'),
            tr(lang, 'POST/PUT/DELETE: таймаут 20 секунд', 'POST/PUT/DELETE: 20 second timeout'),
            tr(lang, 'Параллельные запросы: не более 5-10 одновременных', 'Parallel requests: no more than 5-10 concurrent'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Retry/backoff', 'Retry/backoff'),
          items: [
            tr(lang, 'Повторяйте только идемпотентные запросы (GET, DELETE)', 'Retry only idempotent requests (GET, DELETE)'),
            tr(lang, 'POST /api/v1/transactions можно безопасно повторять с тем же Idempotency-Key в течение 24 часов', 'POST /api/v1/transactions can be safely retried with the same Idempotency-Key within 24 hours'),
            tr(lang, 'Остальные POST/PUT повторяйте только при гарантии, что операция не была выполнена', 'Retry other POST/PUT only if you can guarantee operation was not applied'),
            tr(lang, 'Рекомендуемый backoff: 1s, 2s, 4s (до 3 попыток)', 'Recommended backoff: 1s, 2s, 4s (up to 3 retries)'),
            tr(lang, 'При 429 — обязательно подождите время из Retry-After перед повторной попыткой', 'On 429 — always wait the Retry-After value before retrying'),
          ],
        },
      ],
    },
    {
      id: 'public-api-v1-idempotency',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 35,
      navLabel: tr(lang, 'Идемпотентность', 'Idempotency'),
      title: tr(lang, 'Идемпотентность для POST /api/v1/transactions', 'Idempotency for POST /api/v1/transactions'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Для безопасных повторов операций начисления/списания используйте заголовок Idempotency-Key. Сервер хранит результат и возвращает его повторно для того же ключа.',
            'Use the Idempotency-Key header for safe retry of accrual/write-off operations. The server stores the result and returns it again for the same key.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Правила', 'Rules'),
          items: [
            tr(lang, 'Применяется к: POST /api/v1/transactions', 'Applies to: POST /api/v1/transactions'),
            tr(lang, 'Заголовок: Idempotency-Key: <UNIQUE_KEY>', 'Header: Idempotency-Key: <UNIQUE_KEY>'),
            tr(lang, 'TTL ключа: 24 часа', 'Key TTL: 24 hours'),
            tr(lang, 'Повтор с тем же payload и ключом вернёт тот же ответ', 'Retry with same payload and key returns the same response'),
            tr(lang, 'Повтор с тем же ключом, но другим payload вернёт 409', 'Retry with same key but different payload returns 409'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'v1-tx-idempotency',
          value: `curl -X POST "${api.publicV1}/transactions" \\\n  -H "X-Api-Key: <API_KEY>" \\\n  -H "Idempotency-Key: 5f58c2b6-1cae-4fb2-9f9f-40f4c7f5a4f1" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "card_uuid": "<CARD_UUID>",\n    "client_uuid": "<CLIENT_UUID>",\n    "event": "purchase",\n    "amount": 2400,\n    "points_issued": 120\n  }'`,
        },
      ],
    },
    {
      id: 'public-api-v1-security-pii',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 36,
      navLabel: tr(lang, 'PII и безопасность', 'PII and security'),
      title: tr(lang, 'PII и безопасная эксплуатация', 'PII and secure operations'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Обязательные требования', 'Mandatory requirements'),
          items: [
            tr(lang, 'Используйте только HTTPS для всех запросов', 'Use HTTPS only for all requests'),
            tr(lang, 'Храните API ключи и токены только на сервере/в секрет-хранилище', 'Store API keys and tokens only on server side / secret manager'),
            tr(lang, 'Не передавайте API ключи в клиентские приложения и браузерный JS', 'Do not expose API keys in client apps or browser JS'),
            tr(lang, 'Не логируйте секреты (API ключи, Bearer-токены, integration token)', 'Do not log secrets (API keys, Bearer tokens, integration token)'),
            tr(lang, 'Минимизируйте и маскируйте PII в логах (phone/email/name)', 'Minimize and mask PII in logs (phone/email/name)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Минимальные меры на стороне интегратора', 'Integrator-side baseline controls'),
          items: [
            tr(lang, 'Регулярная ротация ключей и немедленный revoke при подозрении на утечку', 'Regular key rotation and immediate revoke on suspected compromise'),
            tr(lang, 'Раздельные ключи для production и staging', 'Separate keys for production and staging'),
            tr(lang, 'Принцип минимальных прав: выдавайте только необходимые scopes', 'Least privilege: grant only required scopes'),
            tr(lang, 'Контроль retry и дедупликация бизнес-операций', 'Retry control and business operation deduplication'),
          ],
        },
      ],
    },
    {
      id: 'public-api-v1-go-live-checklist',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 37,
      navLabel: tr(lang, 'Go-live checklist', 'Go-live checklist'),
      title: tr(lang, 'Go-live checklist', 'Go-live checklist'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Перед запуском', 'Before launch'),
          items: [
            tr(lang, 'Проверен сценарий: organization → cards → clients → issue → transactions', 'Playbook verified: organization → cards → clients → issue → transactions'),
            tr(lang, 'Для POST /api/v1/transactions включен Idempotency-Key', 'Idempotency-Key is implemented for POST /api/v1/transactions'),
            tr(lang, 'Обработаны 401/403/404/409/422/429 и retry с backoff', '401/403/404/409/422/429 handling and backoff retry are implemented'),
            tr(lang, 'Настроены мониторинг ошибок и алерты по 429/5xx', 'Error monitoring and alerts for 429/5xx are configured'),
            tr(lang, 'Настроена ротация/отзыв ключей и регламент incident response', 'Key rotation/revoke and incident response process are configured'),
          ],
        },
      ],
    },
    {
      id: 'public-api-v1-policy',
      category: tr(lang, 'Public API', 'Public API'),
      navGroup: tr(lang, 'Public API v1', 'Public API v1'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Интеграция', 'Integration'),
      navSubgroupOrder: 45,
      navOrder: 40,
      navLabel: tr(lang, 'Политика изменений и changelog', 'Change policy and changelog'),
      title: tr(lang, 'Политика изменений API v1', 'API v1 change policy'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Что может меняться без breaking change', 'What may change without breaking'),
          items: [
            tr(lang, 'Добавление новых полей в response', 'Adding new fields in responses'),
            tr(lang, 'Добавление новых endpoint в /api/v1', 'Adding new endpoints to /api/v1'),
            tr(lang, 'Расширение списков enum-значений', 'Extending enum value sets'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Что считается breaking change', 'What is considered breaking'),
          items: [
            tr(lang, 'Удаление или переименование endpoint/поля', 'Removing or renaming endpoint/field'),
            tr(lang, 'Изменение типа поля в request/response', 'Changing field type in request/response'),
            tr(lang, 'Ужесточение обязательности существующих полей', 'Making existing optional fields required'),
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Рекомендуем вести changelog для интеграторов в формате: дата, endpoint, тип изменения, требуется ли действие.',
            'Maintain integrator changelog format: date, endpoint, change type, and whether client action is required.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Пример записи в changelog', 'Changelog entry example'),
          key: 'v1-policy-changelog-example',
          value: `2026-02-17 | GET /api/v1/clients | non-breaking | добавлено поле "comment" в response | действия не требуются`,
        },
      ],
    },
  ];
}
